module.exports = __webpack_public_path__ + "img/crsl-impf-7.878ba66b.png";